<app-social-shell active="feed">
  <div class="so-page-head">
    <div>
      <h1>Social <span class="gold">Feed</span></h1>
      <p>What the people, groups and communities you follow are up to.</p>
    </div>
    <app-social-search></app-social-search>
  </div>

  <div class="so-stack">
    <app-social-composer placeholder="Share something with your groups…" (posted)="onPosted()"></app-social-composer>

    <nav class="so-tabs fd-tabs" role="tablist" aria-label="Feed">
      @for (t of tabs; track t.id) {
        <button role="tab" [attr.aria-selected]="tab === t.id" (click)="selectTab(t.id)">{{ t.label }}</button>
      }
    </nav>

    @if (loading) {
      @for (s of skeletons; track s) {
        <div class="so-card fd-skel">
          <div class="fd-skel-head"><span class="so-avatar so-skel"></span><span class="so-skel" style="width: 40%; height: 14px"></span></div>
          <span class="so-skel" style="height: 12px; margin-top: 16px"></span>
          <span class="so-skel" style="height: 12px; width: 70%; margin-top: 8px"></span>
        </div>
      }
    } @else if (feedError) {
      <div class="so-card so-empty">
        <span class="so-empty-icon"><i class="fa fa-wifi"></i></span>
        <h3>Couldn't load your feed</h3>
        <p>Check your connection and try again.</p>
        <button type="button" class="btn btn-theme" (click)="load()">Try again</button>
      </div>
    } @else {
      @for (post of posts; track post.id) {
        <app-social-post-card [post]="post" comments="inline" (removed)="onRemoved($event)"></app-social-post-card>
      } @empty {
        <div class="so-card so-empty">
          @switch (tab) {
            @case ('following') {
              <span class="so-empty-icon"><i class="fa fa-user-plus"></i></span>
              <h3>Your feed is quiet</h3>
              <p>Follow people from their profile, or find someone new in Discover.</p>
              <button type="button" class="btn btn-theme" (click)="selectTab('discover')">Discover people</button>
            }
            @case ('discover') {
              <span class="so-empty-icon"><i class="fa fa-compass"></i></span>
              <h3>Nothing to discover yet</h3>
              <p>When other players post, you'll find them here.</p>
            }
            @case ('communities') {
              <span class="so-empty-icon"><i class="fa fa-users"></i></span>
              @if (hub.snapshot.communities.length) {
                <h3>No community posts yet</h3>
                <p>Start a conversation in one of your communities.</p>
              } @else {
                <h3>You haven't joined a community</h3>
                <p>Find people who play like you do, or start your own.</p>
                <a class="btn btn-theme" routerLink="/communities">Browse communities</a>
              }
            }
            @case ('maps') {
              <span class="so-empty-icon"><i class="fa fa-map-o"></i></span>
              <h3>No posts in your map groups</h3>
              <p>Everyone with access to a map can post in its group.</p>
            }
            @case ('games') {
              <span class="so-empty-icon"><i class="fa fa-gamepad"></i></span>
              <h3>No posts in your games</h3>
              <p>Share a session recap with your party.</p>
            }
            @default {
              <span class="so-empty-icon"><i class="fa fa-pencil"></i></span>
              <h3>You haven't posted yet</h3>
              <p>Share something above.</p>
            }
          }
        </div>
      }
      @if (hasMore) {
        <button type="button" class="so-more" [disabled]="loadingMore" (click)="loadMore()">{{ loadingMore ? 'Loading…' : 'Load more' }}</button>
      }
    }
  </div>

  @if (showBackToTop) {
    <button type="button" class="so-icon-btn so-to-top" aria-label="Back to top" title="Back to top" (click)="scrollToTop()">
      <i class="fa fa-arrow-up"></i>
    </button>
  }
</app-social-shell>
